import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { DataLayer } from 'src/app/shared/models/node';
import { NodeService } from 'src/app/shared/services/node.services';

@Component({
  selector: 'app-view-select-filters',
  templateUrl: './view-select-filters.component.html',
  styleUrls: ['./view-select-filters.component.scss']
})
export class ViewSelectFiltersComponent implements OnInit {

  @Input() block: any;
  @Output() onFiltered = new EventEmitter();
  public valueCheckbox: any[] = [];
  public resetValueCheckbox: boolean = false;
  public filters: any = [];
  public filtersORIGINAL: any = [];
  public filtersNoTextAndKeyword: any = [];
  public filtersKeywordOrProfile: any = [];
  public filtersNoInputText: any = [];
  public filtersInputText: any = [];
  public filtersNoDefault: any = [];
  public colString: string = '';
  private queryParams: any;
  private window: any;
  public isViewReset: boolean = false;
  private changeViewFiltersBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public changeViewFilters: boolean = false;
  public event = "";

  constructor(
    private nodeService: NodeService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.nodeService.isBrowser) {
      this.window = this.nodeService.getWindow();
    }
    this.onInitComponent();
  }

  private onInitComponent(): void {
    this.queryParams = this.activatedRoute.snapshot.queryParams;
    if (this.block && this.block.view_filter_id) {
      this.filters = JSON.parse(JSON.stringify(this.nodeService.viewFilters[this.block.view_filter_id]));
    } else {
      this.filters = [];
    }
    if (this.filters && this.filters.length) {
      let values = this.nodeService.getTaxonomyForView(this.block);
      let j = 0;
      let indiciDaRimuovere = []
      for (let val of values) {
        if (!val) {
          indiciDaRimuovere.push(j);
        }
        j++;
      }
      indiciDaRimuovere.sort((a, b) => b - a);
      for (let i of indiciDaRimuovere) {
        this.filters.splice(i, 1);
      }
      values = values.filter(el => el);
      values.forEach(value => {
        if (value && value.length && value[0]['keyword tematiche']) {
          value[0]['keyword tematiche'] = value[0]['keyword tematiche'].sort(this.sortName);
        }
      })
      let i = 0;
      const qpArr: any = [];
      if (this.queryParams) {
        for (let qp of Object.keys(this.queryParams)) {
          qpArr.push({
            filter_name: qp.replace("[0]", ""),
            value: this.queryParams[qp]
          })
        }
      }
      for (const filter of this.filters) {
        if (values[i]) {
          const val = values && values[i][0];
          const key = Object.keys(val)[0];
          filter.value = val[key];
          if (this.queryParams && this.queryParams[filter.filter_name]) {
            filter.value_sel = {};
            filter.value_sel[filter.filter_name] = this.queryParams[filter.filter_name];
            filter.fromQueryParam = true;
          }
          if (this.queryParams && this.queryParams[filter.filter_type] && this.queryParams.entity === this.block.oggetto_view) {
            filter.value_sel = {};
            filter.value_sel[filter.filter_name] = this.queryParams[filter.filter_type];
            filter.fromQueryParam = true;
          }
          if (this.queryParams && filter.filter_type.indexOf('[]') && this.queryParams[filter.filter_name + '[]']) {
            filter.value_sel = {};
            filter.value_sel[filter.filter_name] = this.queryParams[filter.filter_name + '[]'];
            if (!(filter.value_sel[filter.filter_name] instanceof Array)) {
              filter.value_sel[filter.filter_name] = [this.queryParams[filter.filter_name + '[]']];
            }
            filter.fromQueryParam = true;
          }
          if (this.queryParams) {
            const checkQP = qpArr.filter((q: any) => q.filter_name === filter.filter_name);
            if (checkQP.length) {
              switch (filter.filter_type) {
                case "textList[]": filter.value_sel = {};
                  filter.value_sel[checkQP[0].filter_name] = [checkQP[0].value];
                  break;
                default: null;
              }
            }
          }
          if (filter.value && filter.value.length && filter.refers_to && this.block[filter.refers_to] && this.block[filter.refers_to].length) {
            const terms_id: any = [];
            for (let term of this.block[filter.refers_to]) {
              terms_id.push(term.id);
            }
            if (terms_id.length) {
              filter.value = filter.value.filter((v: any) => terms_id.indexOf(Number(v.term_id)) >= 0);
              if (filter.value.length) {
                for (let value of filter.value) {
                  value.default = true;
                }
              }
            }
          }
        }
        i++;
      }
      this.filtersORIGINAL = JSON.parse(JSON.stringify(this.filters));
      this.setVariableFiltersInput(this.filters);
    }
    this.setColumnItem();
    if (this.nodeService.isBrowser) {
      this.search();
    }
  }

  private setVariableFiltersInput(filter: any): void {
    this.filtersNoDefault = JSON.parse(JSON.stringify(filter));
    this.filtersNoDefault = this.filtersNoDefault.filter((f: any) => f.filter_type !== 'default[]');
    this.filtersNoDefault = this.filtersNoDefault.filter((f: any) => f.filter_type !== 'default');
    this.filtersNoTextAndKeyword = filter.filter((el: any) => el.filter_name !== 'text' && el.filter_name !== 'keyword_tematiche' && el.filter_name !== 'profili_professionali');
    this.filtersKeywordOrProfile = filter.filter((el: any) => el.filter_name !== 'text' && (el.filter_name === 'keyword_tematiche' || el.filter_name === 'profili_professionali'));
    this.filtersNoInputText = this.filtersNoDefault.filter((el: any) => el.filter_name !== 'text' && el.filter_name !== 'Text');
    this.filtersInputText = this.filtersNoDefault.filter((el: any) => el.filter_name === 'text' || el.filter_name === 'Text');
  }

  private sortName(a: any, b: any): any {
    const name1 = a.name.toUpperCase();
    const name2 = b.name.toUpperCase();
    let comparison = 0;
    if (name1 > name2) {
      comparison = 1;
    } else if (name1 < name2) {
      comparison = -1;
    }
    return comparison;
  }

  public search(queryParams: string = '', toOtherPage: boolean = false, route?: string): void {
    let text = null;
    let queryParamsRoute = null
    if (this.filters && this.filters.length) {
      let filters: any = [];
      const filtersDefaultToRemove: any = [];

      for (const filter of this.filters) {
        const found = this.filtersNoDefault.findIndex((f: any) => f.filter_name === filter.filter_name)
        if (found >= 0) {
          filter.value_sel = this.filtersNoDefault[found].value_sel;
        }
      }

      for (const filter of this.filters) { // prendo i filtri di default da eliminare perchè è stato settato solo 1 o + valori di quel filtro
        const hasValuesSelected = filter.value_sel && filter.value_sel.values_selected && filter.value_sel.values_selected[0];
        const hasQueryParamValues = filter.value_sel && filter.value_sel[filter.filter_name] && filter.value_sel[filter.filter_name].length;
        if (filter && filter.refers_to && (hasValuesSelected || hasQueryParamValues)) {
          filtersDefaultToRemove.push(filter.refers_to);
        }
      }

      if (filtersDefaultToRemove && filtersDefaultToRemove.length) { // prendo i filtri escludendo quelli di default da eliminare
        for (const filter of this.filters) {
          if (filtersDefaultToRemove.indexOf(filter.filter_name) < 0) {
            filters.push(filter);
          }
        }
      } else {
        filters = this.filters;
      }
      for (const filter of filters) {
        if (filter.value_sel) {
          this.changeViewFiltersBS.next(true);
          this.isViewReset = true;
          // vocabulary[]
          if (filter.filter_type === 'vocabulary[]' && filter.value_sel.values_selected && filter.value_sel.values_selected.length) {
            for (const val of filter.value_sel.values_selected) {
              queryParams += `&${filter.filter_name}%5B%5D=${val.term_id}`;
            }
          }
          if (filter.filter_type === 'vocabulary[]' && filter.value_sel && filter.value_sel[filter.filter_name] &&
            filter.value_sel[filter.filter_name].length) {
            for (const val of filter.value_sel[filter.filter_name]) {
              queryParams += `&${filter.filter_name}%5B%5D=${val}`;
            }
          }
          // textList[]
          if (filter.filter_type === 'textList[]' && filter.value_sel.values_selected && filter.value_sel.values_selected.length) {
            for (const val of filter.value_sel.values_selected) {
              queryParams += `&${filter.filter_name}%5B%5D=${val.id}`;
            }
          }
          if (filter.filter_type === 'textList[]' && filter.value_sel && filter.value_sel[filter.filter_name] &&
            filter.value_sel[filter.filter_name].length) {
            for (const val of filter.value_sel[filter.filter_name]) {
              queryParams += `&${filter.filter_name}%5B%5D=${val}`;
            }
          }

          if (filter.filter_type === 'vocabulary') {
            if (filter.filter_name === 'categorie_convenzione') {
              queryParams += `&${filter.filter_name}=${filter.value_sel['categorie_convenzione']}`;
            } else {
              queryParams += `&${filter.filter_name}=${filter.value_sel.text}`;
            }
          }
          if (filter.filter_type === 'textList') {
            if (filter.value_sel.field_status) {
              queryParams += `&${filter.filter_name}=${filter.value_sel.field_status}`;
            }
            if (filter.value_sel.field_tipologia_evento) {
              queryParams += `&${filter.filter_name}=${filter.value_sel.field_tipologia_evento}`;
            }
            if (filter.value_sel.soluzione) {
              queryParams += `&${filter.filter_name}=${filter.value_sel.soluzione}`;
            }
            if (filter.value_sel.quartiere) {
              queryParams += `&${filter.filter_name}=${filter.value_sel.quartiere}`;
            }
          }
          if (filter.filter_type === 'text' || filter.filter_type === 'Text') {
            if (filter.value_sel.text) {
              queryParams += `&${filter.filter_name}=${filter.value_sel.text}`;
              text = filter.value_sel.text;
            }
            if (filter.value_sel.Text) {
              queryParams += `&${filter.filter_name.toLowerCase()}=${filter.value_sel.Text}`;
              text = filter.value_sel.Text;
            }
            if (filter.value_sel['prezzo-from']) {
              queryParams += `&${filter.filter_name}=${filter.value_sel['prezzo-from']}`;
              text = filter.value_sel['prezzo-from'];
            }
            if (filter.value_sel['prezzo-to']) {
              queryParams += `&${filter.filter_name}=${filter.value_sel['prezzo-to']}`;
              text = filter.value_sel['prezzo-to'];
            }
          }
          if (filter.filter_type === 'date') {
            // if (filter.filter_type === 'vocabulary[]' && filter.value_sel && filter.value_sel[filter.filter_name] &&
            //   filter.value_sel[filter.filter_name].length) {
            //   for (const val of filter.value_sel[filter.filter_name]) {
            //     queryParams += `&${filter.filter_name}%5B%5D=${val}`;
            //   }
            // }
            if (filter.value_sel.from) {
              queryParams += `&${filter.filter_name}=${filter.value_sel.from}`;
            }
            if (filter.value_sel.to) {
              queryParams += `&${filter.filter_name}=${filter.value_sel.to}`;
            }
            if (filter.value_sel['eventi-from']) {
              queryParams += `&${filter.filter_name}=${filter.value_sel['eventi-from']}`;
            }
            if (filter.value_sel['eventi-to']) {
              queryParams += `&${filter.filter_name}=${filter.value_sel['eventi-to']}`;
            }
          }
        }
        // default[]
        if (filter.filter_type === 'default[]' && this.block[filter.filter_name]) {
          for (const val of this.block[filter.filter_name]) {
            queryParams += `&${filter.filter_name}%5B%5D=${val.id}`;
          }
        }
      }
    }
    if (queryParams) {
      queryParams = queryParams.substring(1);
      this.isViewReset = true;
    } else {
      queryParams = '';
    }
    queryParamsRoute = (' ' + queryParams).slice(1);
    for (let filter of this.filters) {
      if (filter.filter_type === 'default[]' && this.block[filter.filter_name]) {
        queryParamsRoute = this.removeQueryParam(filter.filter_name + '[]', queryParamsRoute)
      }
    }
    this.onFiltered.emit({ queryParamsRoute, queryParams, event: this.event });
    this.event = "";
    if (this.block.oggetto_view === "faq-procedure") {
      this.setDataLayer(text);
    }
    if (toOtherPage && route) {
      const routeUrl = `${route}?${queryParams}`;
      this.router.navigateByUrl(routeUrl);
    }
  }

  private removeQueryParam(key:any, queryparams:any) {
    const urlObj = new URL("https://example.com/page?" + queryparams);
    const params = urlObj.searchParams;
    params.delete(key);

    return (params.toString() ? params.toString() : "");

  }



  public resetValue(): void {
    this.filters = JSON.parse(JSON.stringify(this.filtersORIGINAL));
    for (let f of this.filters.filter((filter: any) => filter.fromQueryParam)) {
      f.value_sel = undefined;
    }
    this.setVariableFiltersInput(this.filters);
    this.resetValueCheckbox = true;
    this.isViewReset = false;
    this.search();
    this.changeViewFiltersBS.next(false);
  }

  private setColumnItem() {
    //Elimino type text da contteggio delle colonne
    this.changeViewFiltersBS.pipe().subscribe(valueBoolean => {
      this.changeViewFilters = valueBoolean;
      const filter = this.filtersNoInputText.length;
      switch (filter) {
        case 1:
          this.colString = 'col-12 col-lg-12';
          break;
        case 2:
          this.colString = 'col-12 col-lg-6';
          break;
        case 3:
          this.colString = 'col-12 col-lg-4';
          break;
        case 4:
          this.colString = 'col-12 col-lg-3';
          break;
        case 5:
          this.colString = 'col-12 width-20';
          break;
        case 6:
          this.colString = 'col-12 col-lg-2 width-grow';
          break;
        default:
          this.colString = 'col-12';
          break;
      }
      if (this.block && this.block.bundle === 'blocco_corsi_di_laurea_tutti_' && !valueBoolean) {
        this.colString = 'col-12 col-lg-3';
      }
    })
  }

  public setDataLayer(text: string) {
    if (this.nodeService.isBrowser) {
      const dataLayer: DataLayer = {
        event: 'Search',
        location: this.window.frames.location.origin,
        pagePath: this.window.frames.location.pathname,
        TypeSearch: 'Faq',
        query: text
      }
      this.window.dataLayer = this.window.dataLayer || [];
      this.window.dataLayer.push(dataLayer);
    }
  }

  public setVariable(): void {
    this.resetValueCheckbox = false;
    this.isViewReset = true;
  }
}
